import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ProtectedRoute } from "../ProtectedRoute/ProtectedRoute";
import { USER_ROLES } from "@/config/admin";

interface AdminRouteProps {
  children: ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  return (
    <ProtectedRoute>
      <AdminGuard>{children}</AdminGuard>
    </ProtectedRoute>
  );
}

function AdminGuard({ children }: { children: ReactNode }) {
  const { profile } = useAuth();

  if (profile?.role !== USER_ROLES.ADMIN) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
